import { DISCARDED_RESPONSE_STRINGS } from 'garaje/utils/enums';
import visitorsClassicScenario from './visitors-classic';

/**
 * Sets up Employee Registration Mirage Scenario
 * - `MIRAGE_SCENARIO='employee-registration' yarn start:mirage`
 *
 * @param {object} server Mirage Server
 */
export default function (server) {
  const {
    locations: [location],
  } = visitorsClassicScenario(server);

  location.update({ employeeScreeningEnabled: true });

  const globalFlow = server.create(
    'employee-screening-flow',
    'withSummaryPage',
    'withSignInFieldPage',
    'withAgreementPage',
    {
      enabled: true,
      locationIds: [location.id],
    }
  );

  server.create('flow', {
    enabled: true,
    name: 'Employee registration overridden',
    type: 'Flows::EmployeeScreening',
    employeeCentric: true,
    location,
  });

  const { signInFieldPage } = globalFlow;
  server.create('employee-sign-in-field', { signInFieldPage, name: DISCARDED_RESPONSE_STRINGS.PLACEHOLDER });
  server.create('employee-sign-in-field', { signInFieldPage, name: 'Stored field' });

  server.create('entry', {
    location,
    flowName: 'Employee registration overridden',
    employeeScreeningFlow: true,
    userData: [
      {
        field: 'Discarded field',
        value: DISCARDED_RESPONSE_STRINGS.DISPLAY_TEXT,
      },
      { field: 'Stored field', value: 'Hi' },
      { field: 'Purpose of visit', value: 'Employee registration' },
    ],
  });
}
